import { EventFormData } from '~admin/view/components/details/event-form-data';
import { getAdditionalDetailsRequest } from '~admin/view/components/create-event/helper/event-profile-request/event-additional-details-request.helper';
import {
  getEventBaseDetailsRequest,
  getEventBaseDetailsTranslationsRequest,
} from '~admin/view/components/create-event/helper/event-profile-request/event-base-details-request.helper';
import { getEventClientDetailsRequest } from '~admin/view/components/create-event/helper/event-profile-request/event-client-details-request.helper';
import { getEventDatetimeDetailsRequest } from '~admin/view/components/create-event/helper/event-profile-request/event-datetime-details-request.helper';
import { getEventFeeDetailsRequest } from '~admin/view/components/create-event/helper/event-profile-request/event-fee-details-request.helper';
import { getEventLocationDetailsRequest } from '~admin/view/components/create-event/helper/event-profile-request/event-location-details-request.helper';
import { getEventMediaDetailsRequest } from '~admin/view/components/create-event/helper/event-profile-request/event-media-details-request.helper';
import { getEventOptionDetailsRequest } from '~admin/view/components/create-event/helper/event-profile-request/event-option-details-request.helper';
import { getEventSponsorDetailsRequest } from '~admin/view/components/create-event/helper/event-profile-request/event-sponsor-details-request.helper';
import {
  getEventTimelineDetailsRequest,
  getEventTimelineDetailsTranslationsRequest,
} from '~admin/view/components/create-event/helper/event-profile-request/event-timeline-details-request.helper';
import { EventProfileCreateRequest } from '~client/model/admin/event-profile-create-request';
import {
  getEventRestrictionsRequest,
  getEventRestrictionsTranslationsRequest,
} from '~admin/view/components/create-event/helper/event-profile-request/event-restrictions-request.helper';
import { EventTranslationRequest } from '~client/model/admin/event-translation-request';
import { EventRestrictionResponse } from '~client/model/event-restriction-response';
import { EventTimelineGroupResponse } from '~client/model/event-timeline-group-response';

/**
 * Transforms CreateEventFormData to EventProfileCreateRequest
 * @param values
 */
export const getEventProfileRequest = (values: EventFormData): EventProfileCreateRequest => {
  const clientDetailsRequest = getEventClientDetailsRequest(values);
  const eventBaseDetailsRequest = getEventBaseDetailsRequest(values);
  const locationDetailsRequest = getEventLocationDetailsRequest(values);
  const mediaDetailsRequest = getEventMediaDetailsRequest(values);
  const datetimeDetailsRequest = getEventDatetimeDetailsRequest(values);
  const optionDetailsRequest = getEventOptionDetailsRequest(values);
  const feeDetails = getEventFeeDetailsRequest(values);
  const timelineDetailsRequest = getEventTimelineDetailsRequest(values);
  const restrictionsRequest = getEventRestrictionsRequest(values);
  const sponsorDetailsRequest = getEventSponsorDetailsRequest(values);
  const additionalDetailsRequest = getAdditionalDetailsRequest();

  return {
    ...clientDetailsRequest,
    ...eventBaseDetailsRequest,
    ...locationDetailsRequest,
    ...mediaDetailsRequest,
    ...datetimeDetailsRequest,
    ...optionDetailsRequest,
    ...feeDetails,
    ...timelineDetailsRequest,
    ...restrictionsRequest,
    ...sponsorDetailsRequest,
    ...additionalDetailsRequest,
  };
};

/**
 * Transforms CreateEventFormData to EventTranslationRequest
 * @param eventId
 * @param eventRestrictions
 * @param eventTimelineGroupsResponse
 * @param values
 */
export const getEventTranslationRequest = (
  eventId: string,
  eventRestrictions: EventRestrictionResponse[],
  eventTimelineGroupsResponse: EventTimelineGroupResponse[],
  values: EventFormData,
): EventTranslationRequest => {
  const eventBaseDetailsTranslationsRequest = getEventBaseDetailsTranslationsRequest(values);
  const eventTimelineDetailsTranslationsRequest = getEventTimelineDetailsTranslationsRequest(
    eventTimelineGroupsResponse,
    values,
  );
  const eventRestrictionsTranslationsRequest = getEventRestrictionsTranslationsRequest(
    eventRestrictions,
    values,
  );

  return {
    eventId,
    ...eventBaseDetailsTranslationsRequest,
    ...eventTimelineDetailsTranslationsRequest,
    ...eventRestrictionsTranslationsRequest,
  };
};



// WEBPACK FOOTER //
// ./view/components/create-event/helper/event-profile-request.helper.ts